// src/lib/authkit/shared.ts

/** 認証済みユーザー情報の型 */
export interface AuthUser {
  id: string;
  email: string;
  display_name?: string;
  roles: string[];
  isDedicatedStaff: boolean;
  isStaff: boolean;
  [key: string]: unknown;
}

/** 安全なオブジェクト判定 */
function isObjectRecord(v: unknown): v is Readonly<Record<string, unknown>> {
  return typeof v === 'object' && v !== null;
}

/** unknown → string[] 変換（型ガード付き） */
function asStringArray(v: unknown): string[] {
  return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string') : [];
}

/** user オブジェクトの正規化（roles の位置・flags の有無が揺れても吸収） */
export function normalizeUser(payload: unknown): AuthUser {
  const base = isObjectRecord(payload) ? payload : {};
  const inner = isObjectRecord(base.user) ? (base.user as Readonly<Record<string, unknown>>) : {};

  const id =
    typeof inner.id === 'string'
      ? inner.id
      : typeof base.id === 'string'
        ? base.id
        : '';

  const email =
    typeof inner.email === 'string'
      ? inner.email
      : typeof base.email === 'string'
        ? base.email
        : '';

  const display_name =
    typeof inner.display_name === 'string'
      ? inner.display_name
      : typeof base.display_name === 'string'
        ? base.display_name
        : undefined;

  const rolesFromUser = asStringArray(inner.roles);
  const rolesTop = asStringArray(base.roles);
  const roles = rolesFromUser.length > 0 ? rolesFromUser : rolesTop;

  const isDedicatedStaff =
    (typeof inner.isDedicatedStaff === 'boolean' && inner.isDedicatedStaff) ||
    (typeof base.isDedicatedStaff === 'boolean' && base.isDedicatedStaff) ||
    false;

  const isStaffFlag =
    (typeof inner.isStaff === 'boolean' && inner.isStaff) ||
    (typeof base.isStaff === 'boolean' && base.isStaff) ||
    false;

  return {
    ...base,
    id,
    email,
    display_name,
    roles,
    isDedicatedStaff,
    isStaff: isStaffFlag,
  };
}

/** 専任/スタッフ扱いの判定（roles or flags のどれかが真なら true） */
export function isStaff(user: AuthUser | null): boolean {
  if (!user) return false;
  if (user.isDedicatedStaff || user.isStaff) return true;
  return Array.isArray(user.roles) && user.roles.includes('staff');
}
